import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import Navbar from "../../../layout/Navbar";
import CrmSidebar from "./CrmSidebar";

export default function CrmLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="app-shell">
      <CrmSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="app-main">
        <Navbar onMenuToggle={() => setSidebarOpen((open) => !open)} />

        <main className="app-content">
          <div key={location.pathname} className="content-inner page-enter">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
